import { createContext, useContext, useEffect } from 'react'

import type { Navbar } from '@/cms/pages'

type SetNavbar = (navbar: Navbar | undefined) => void

const NavbarContext = createContext<SetNavbar>(() => undefined)

export const NavbarProvider = NavbarContext.Provider

export const useShareNavbar = (navbar: Navbar | undefined) => {
  const setNavbar = useContext(NavbarContext)

  useEffect(() => {
    setNavbar(navbar)
    return () => setNavbar(undefined)
  }, [navbar, setNavbar])
}
